import React from 'react'

const About = () => {
  return (
    <div>
       <h1>About</h1>
   <h3>Total:</h3>
   <hr width="80%"/>
    </div>
    
  )
}

export default About